import { useEffect, useState } from 'react';
import { tryFetch } from 'Helpers/FetchAPI';

interface ReviewResponse {
  average_rating: string;
  product_reviews: any[];
}

export const useAverageRating = (merchantId: string, blockId: string) => {
  const [averageRating, setAverageRating] = useState<string>('0');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAverageRating = async () => {
      try {
        const response = await tryFetch({
          url: `/merchant/${merchantId}/product/${blockId}/reviews`,
          method: 'GET',
        });

        if (
          response.is_success &&
          response.data &&
          typeof response.data === 'object' &&
          'average_rating' in response.data
        ) {
          const data = response.data as ReviewResponse;
          setAverageRating(data.average_rating);
        } else {
          throw new Error('Invalid response structure');
        }
      } catch (err: any) {
        console.error('Error fetching average rating:', err);
        setError(err.message || 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchAverageRating();
  }, [merchantId, blockId]);

  return { averageRating, loading, error };
};
